module.exports = __webpack_public_path__ + "img/quasar.e68f134e.png";